module.exports = __webpack_public_path__ + "img/sample.f1a5ddc0.jpg";